import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { bidsBackend } from './bids.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { bidsReducer } from './bids.reducer';

// FIXME: remove that
backend.bids = bidsBackend;

@NgModule({
  imports: [
    StoreModule.forFeature('bids', bidsReducer),
    /* DatastoreBackendModule.forFeature(
      'bids',
      bidsBackend,
    ),*/
  ],
})
export class DatastoreBidsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/bids/bids.module.ts